/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} General_Delete_Confirm_TitleInputs */

const en_general_delete_confirm_title = /** @type {(inputs: General_Delete_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm Deletion`)
};

const de_general_delete_confirm_title = /** @type {(inputs: General_Delete_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Löschen bestätigen`)
};

/**
* | output |
* | --- |
* | "Confirm Deletion" |
*
* @param {General_Delete_Confirm_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const general_delete_confirm_title = /** @type {((inputs?: General_Delete_Confirm_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<General_Delete_Confirm_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_general_delete_confirm_title(inputs)
	return de_general_delete_confirm_title(inputs)
});